// @flow
import * as React from 'react';
import { Box } from 'grommet';
import LabelText from 'esm-web-pro/components/layout/sidePanel/LabelText';


type Props = {
    children: React.Node,
};

const ContentLabel = (props: Props) => {
    const { children } = props;
    return (
        <Box pad={{ left: 'medium' }}>
            <LabelText>{children}</LabelText>
        </Box>
    );
};

export default ContentLabel;
